<template>
    <v-dialog v-model="dialog" persistent max-width="800px" light>
        <v-card color="rgb(255, 0, 0, 0.2)">
            <v-toolbar class="custom-font-regular requerimiento-toolbar" color="#dedfe4">
                <v-toolbar-title>Observación</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items right>
                    <v-btn icon @click="hideDialog"><v-icon>close</v-icon></v-btn>
                </v-toolbar-items>
            </v-toolbar>
            <v-card class="body-content">
                <div class="body-content">
                    {{ observacion.modified }} - {{ observacion.author.firstName }} {{ observacion.author.lastName }}
                    <span>({{ observacion.author.departamento }})</span>:
                </div>
                <div class="text-content">Editar:</div>
                <v-textarea class="body-content" v-model="currentText" single-line outline ></v-textarea>
                <v-card-actions>
                    <v-btn color="error" flat @click="hideDialog">Cancelar</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" flat  @click="saveEdit()" :disabled="loading || isEmpty">Guardar</v-btn>
                </v-card-actions>
            </v-card>

        </v-card>
    </v-dialog>
</template>

<script>

export default {
  props: {
    observacion: Object,
    editable: Boolean,
    editPath: String
  },

  data () {
    return {
      loading: false,
      dialog: true,
      currentText: this.observacion.observacion
    }
  },

  computed: {
    isEmpty () {
      return this.currentText === ''
    }
  },
  methods: {

    hideDialog () {
      this.$emit('hideDialog')
    },
    getPayload () {
      const payload = {
        observacion: this.currentText
      }
      return payload
    },
    saveEdit () {
      this.loading = true
      let payload = this.getPayload()
      this.axios
        .put(`${this.editPath}/${this.observacion.pk}`, payload)
        .then((response) => {
          this.$emit('updateObservacion', response.data)
          this.loading = false
        })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    }
  }
}
</script>

<style scoped>
    .custom-font-regular {
        font-family: SourceSansProRegular, sans-serif;
    }

    .body-content {
        padding: 5px;
        background-color: #e9eaec;
    }

    .text-content {
        padding: 1em 0.5em 0.5em 0.5em;
        background-color: #e9eaec;
    }
</style>
